(function() {
    angular
        .module("loginModule")
        .config(loginRouter)

    loginRouter.$inject = [
        "$stateProvider",
        "$urlRouterProvider",
        "$locationProvider"
    ]

    function loginRouter(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider
    ){
        $stateProvider
            .state("login", {
                url: "/login",
                templateUrl: "app/components/login/login.view.html",
                controller : "LoginController"
            })
            .state("forgot", {
                url: "/forgot",
                templateUrl: "app/components/login/forgot.view.html",
                controller : "ForgotController"
            })
            .state("reset", {
                url: "/password-reset/:password_reset_token",
                templateUrl: "app/components/login/reset.view.html",
                controller : "ResetPasswordController"
            })
            .state("user-confirmation", {
                url: "/user-confirmation/:confirmation_token",
                templateUrl: "app/components/login/user-confirmation.view.html",
                controller : "UserConfirmationController"
            })

            $urlRouterProvider.otherwise("/")

        $locationProvider.html5Mode(true)
    }
})()
